import styled from 'styled-components';
import { FaBars, FaTimes } from 'react-icons/fa';
import InlineSVG from 'svg-inline-react';
import { Link as NavLink } from 'react-router-dom';
import { BLACK } from '../../theme';

const MOBILE_HEADER_WIDTH = `40.625rem`;

export const NavButton = styled(FaBars)`
  height: 1.5rem;
  width: 1.5rem;
  color: ${BLACK};
  margin: 1.25rem 0.625rem 1.25rem 1.25rem;
  cursor: pointer;

  @media only screen and (max-width: ${MOBILE_HEADER_WIDTH}) {
    margin: 0;
    height: 2.2rem;
  }
`;

export const Link = styled(NavLink)`
  width: 100%;
  height: 100%;
  padding-left: 1.25rem;
  font-size: 1rem;
  display: flex;
  align-items: center;
  color: #4a4a4a;
  text-decoration: none;

  font-weight: ${((props) => (props.active === `true` ? `700` : `400`))};
  &:hover {
    cursor: pointer;
    text-decoration: none;
  }
`;

export const ExternalNavLink = styled.a`
  width: 100%;
  height: 100%;
  padding-left: 1.25rem;
  font-size: 1rem;
  display: flex;
  align-items: center;
  color: #4a4a4a;
  text-decoration: none;

  font-weight: ${((props) => (props.active === `true` ? `700` : `400`))};
  &:hover {
    cursor: pointer;
    text-decoration: none;
  }
`;

export const NavMenu = styled.nav`
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  min-height: 100vh;
  height: 100%;
  width: 25rem;
  overflow-x: hidden;
  overflow-y: auto;
  background: white;
  visibility: hidden;
  box-shadow: 5px 0px 0.625rem #555;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  * {
    transition: 500ms ease;
  }

  @media (max-width: ${MOBILE_HEADER_WIDTH}) {
    width: 80vw;
    min-width: 18.75rem;
    max-width: 25rem;
  }
`;

export const NavClose = styled(FaTimes)`
  height: 1.5rem;
  width: 1.5rem;
  color: ${BLACK};
  margin-top: 1rem;
  margin-left: 1.25rem;
  cursor: pointer;

  @media (max-width: 31.25rem) {
    top: 1.25rem;
    left: 0.625rem;
  }
`;

export const NavOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: #000;
  z-index: 999;
  visibility: hidden;
`;

export const NavIcon = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.625rem;
  fill: ${BLACK};

`;

export const NavList = styled.ul`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  list-style-type: none;
  padding: 0;
  font-family: "Calistoga";
  margin-bottom: 0;

  li:first-child {
    a {
      border-top: 1px #E7EDEE solid;
    }
  }
`;

export const NavItem = styled.li`
  width: 100%;
  height: 4.375rem;
  display: flex;
  justify-content: center;

  background: ${(props) =>
    props.active ? `#E4F3F3` : `transparent`};
  &:hover {
    background: #e4f3f3;
  }

  a {
    border-bottom: 1px #E7EDEE solid;
  }
`;

export const NavButtonText = styled.div`
  font-family: "PT Sans";
  font-weight: 700;
  color: ${BLACK};
  font-size: 1.25rem;

  @media only screen and (max-width: ${MOBILE_HEADER_WIDTH}) {
    display: none;
  }
`;

export const NavButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const SVGIcon = styled(InlineSVG)``;
